import * as React from "react";
import { DataGrid } from "@material-ui/data-grid";

const columns = [
  { field: "id", headerName: "", width: 70 },
  {
    field: "pregnancies",
    headerName: "Pregnancies",
    type: "number",
    width: 200,
  },
  { field: "glucose", headerName: "Glucose", type: "number", width: 130 },
  {
    field: "bloodPressure",
    headerName: "Bloodpressure",
    type: "number",
    width: 300,
  },
  {
    field: "skinThickness",
    headerName: "Skinthickness",
    type: "number",
    width: 300,
  },
  { field: "insulin", headerName: "Insulin", type: "number", width: 300 },
  { field: "bmi", headerName: "BMI", type: "number", width: 100 },
  {
    field: "diabetesPedigreeFunction",
    headerName: "DiabetesPedigreeFunction",
    type: "number",
    width: 400,
  },
  { field: "age", headerName: "Age", type: "number", width: 100 },
  { field: "outcome", headerName: "Outcome", type: "number", width: 200 },
];

const rows = [
  {
    id: "count",
    pregnancies: 768,
    glucose: 768,
    bloodPressure: 768,
    skinThickness: 768,
    insulin: 768,
    bmi: 768,
    diabetesPedigreeFunction: 768,
    age: 768,
    outcome: 768,
  },
  {
    id: "mean",
    pregnancies: 3.845052,
    glucose: 120.89453,
    bloodPressure: 69.105469,
    skinThickness: 20.536458,
    insulin: 79.79948,
    bmi: 31.99258,
    diabetesPedigreeFunction: 0.471876,
    age: 33.24089,
    outcome: 0.348958,
  },
  {
    id: "std",
    pregnancies: 3.369578,
    glucose: 31.972618,
    bloodPressure: 19.355807,
    skinThickness: 15.952218,
    insulin: 115.244,
    bmi: 7.88416,
    diabetesPedigreeFunction: 0.331329,
    age: 11.76023,
    outcome: 0.476951,
  },
  {
    id: "min",
    pregnancies: 0,
    glucose: 0,
    bloodPressure: 0,
    skinThickness: 0,
    insulin: 0,
    bmi: 0,
    diabetesPedigreeFunction: 0.078,
    age: 21,
    outcome: 0,
  },
  {
    id: 0.25,
    pregnancies: 1,
    glucose: 99,
    bloodPressure: 62,
    skinThickness: 0,
    insulin: 0,
    bmi: 27.3,
    diabetesPedigreeFunction: 0.24375,
    age: 24,
    outcome: 0,
  },
  {
    id: 0.5,
    pregnancies: 3,
    glucose: 117,
    bloodPressure: 72,
    skinThickness: 23,
    insulin: 30.5,
    bmi: 32,
    diabetesPedigreeFunction: 0.3725,
    age: 29,
    outcome: 0,
  },
  {
    id: 0.75,
    pregnancies: 6,
    glucose: 140.25,
    bloodPressure: 80,
    skinThickness: 32,
    insulin: 127.25,
    bmi: 36.6,
    diabetesPedigreeFunction: 0.62625,
    age: 41,
    outcome: 1,
  },
  {
    id: "max",
    pregnancies: 17,
    glucose: 199,
    bloodPressure: 122,
    skinThickness: 99,
    insulin: 846,
    bmi: 67.1,
    diabetesPedigreeFunction: 2.42,
    age: 81,
    outcome: 1,
  },
];

export default function DataTable(props) {
  return (
    <div style={{ height: 450, width: "100%" }}>
      <DataGrid rows={rows} columns={columns} pageSize={5} />
    </div>
  );
}
